<template>
  <div class="prequal-container shadow">
    <div class="lender-container">
      <img :src="lenderImage" :alt="lenderName" />
    </div>
    <div class="column-two">
      <div class="amount">
        <p class="finance-details-top mt-0 mb-1">
          {{ $t(`message.credit.inventoryMatching.prequalification.loanAmount`) }}
        </p>
        <div class="finance-details-bottom">{{ $n(loanAmount, 'currencyDollars', languageCode) }}</div>
      </div>
      <div class="payment">
        <p class="finance-details-top mt-0 mb-1">
          {{ $t(`message.credit.inventoryMatching.prequalification.paymentAmount`) }}
        </p>
        <div class="finance-details-bottom">
          {{ $n(monthlyPayment, 'currencyDollars', languageCode) }}/{{ $t('message.common.month') }}
        </div>
      </div>
      <div v-if="displayLoanTerm" class="payment-months">
        <p class="finance-details-top mt-0 mb-1">
          {{ $t(`message.credit.inventoryMatching.prequalification.loanTerm`) }}
        </p>
        <div class="finance-details-bottom">{{ loanTermInMonths }} {{ $t('message.common.monthPlural') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrequalFinanceProviderCodes from '@/utils/enums/prequalFinanceProviderCodes';

// To-do Add french translations
export default {
  name: 'FinanceLenderCardLite',
  data() {
    return {
      lenderImage: '',
      PrequalFinanceProviderCodes,
    };
  },
  props: {
    lenderKey: {
      type: String,
      required: true,
      validator(value) {
        return [PrequalFinanceProviderCodes.TD, PrequalFinanceProviderCodes.GL].includes(value);
      },
    },
    lenderName: {
      type: String,
      required: true,
    },
    loanAmount: {
      type: [String, Number],
      required: true,
    },
    monthlyPayment: {
      type: [String, Number],
      required: true,
    },
    loanTermInMonths: {
      type: [String, Number],
      required: false,
    },
  },
  components: {},
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    displayLoanTerm() {
      return (typeof this.loanTermInMonths).match(/string|number/);
    },
  },
  methods: {
    async getLenderImage() {
      if (this.lenderKey) {
        // Prevent non-existent image from stopping the component from rendering
        try {
          // eslint-disable-next-line
          this.lenderImage = await require(`@/assets/prequal-lenders/${this.lenderKey}-logo.svg`);
        } catch (e) {
          // Nothing for now
        }
      }
    },
  },
  mounted() {
    this.getLenderImage();
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

.prequal-container {
  padding: 24px;
  border-radius: 6px;
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-template-rows: 1fr;
  column-gap: 32px;
  align-items: flex-start;

  .lender-container {
    img {
      width: 48px;
    }
  }

  .column-two {
    display: flex;
    column-gap: 48px;
    row-gap: 20px;
    flex-wrap: wrap;
  }

  .amount {
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
  }

  p.finance-details-top {
    font-size: 12px;
    line-height: 18px;
  }

  .finance-details-bottom {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
  }
}

/* Mobile only */
@media only screen and (max-width: $breakpoint-mobile) {
  .prequal-container {
    padding: 16px;
    padding-bottom: 24px;
    column-gap: 20px;
  }
}
</style>
